import { apiBaseURL } from '../ProjectConstants';

/*
 =-=-=-=-=- data structure -=-=-=-=-=
    id: int,
    location: str,
*/
async function handlePutDeliveryLocations(locationData, fetch) {
    const body = {
        id: locationData.id,
        location: locationData.location
    };

    const response = await fetch.put(`${apiBaseURL}/api/DeliveryLocation`, body);
    const isDataGood = response?.success && response?.data?.statusCode && response?.success !== 'Invalid Model';

    console.log('handlePutDeliveryLocations', body);
    console.log('handlePutDeliveryLocations response', response);

    return {
        response,
        isDataGood
    };
}
export default handlePutDeliveryLocations;